<div class="ai-suggestions-section">
	<!-- Header with gradient background and magic icon -->
	<div class="suggestions-header">
		<div class="header-content">
			<mat-icon class="magic-icon">auto_fix_high</mat-icon>
			<h3>Suggested Areas</h3>
			<button
				*ngIf="hasAnalyzed && !isLoading && suggestions.length > 0"
				mat-button
				class="clear-button"
				(click)="clearSuggestions()">
				Clear
			</button>
		</div>

		<!-- Custom Instructions Textarea (shown when toggled) -->
		<textarea
			*ngIf="showCustomInstructions && !hasAnalyzed && !isLoading"
			class="custom-instructions-textarea"
			[(ngModel)]="customInstructions"
			placeholder="Enter custom instructions for AI analysis..."
			rows="3"></textarea>

		<!-- Initial State: Analyze Button with Context Menu -->
		<div *ngIf="!hasAnalyzed && !isLoading" class="analyze-button-container">
			<button
				mat-raised-button
				class="analyze-button"
				(click)="startAnalysis()">
				<mat-icon>auto_fix_high</mat-icon>
				ANALYZE
			</button>
			<button
				mat-icon-button
				class="context-menu-button"
				[matMenuTriggerFor]="analyzeMenu">
				<mat-icon>more_vert</mat-icon>
			</button>
			<mat-menu #analyzeMenu="matMenu" class="tiny">
				<button mat-menu-item (click)="toggleCustomInstructions()">
					<mat-icon>{{ showCustomInstructions ? 'check' : '' }}</mat-icon>
					<span>Custom Instructions</span>
				</button>
			</mat-menu>
		</div>

		<!-- Loading State -->
		<div *ngIf="isLoading" class="loading-state">
			<mat-spinner diameter="20"></mat-spinner>
			<span>Analyzing...</span>
		</div>

		<!-- Error State -->
		<div *ngIf="error && hasAnalyzed" class="error-state">
			<p class="error-message">{{error}}</p>
			<button mat-button class="retry-button" (click)="onRetry()">
				<mat-icon>refresh</mat-icon>
				RETRY
			</button>
		</div>

		<!-- Suggestions List (Minimized) -->
		<div *ngIf="!isLoading && !error && hasAnalyzed && suggestions.length > 0" class="suggestions-list">
			<div
				*ngFor="let suggestion of suggestions; let i = index"
				class="suggestion-item"
				(click)="onPreviewSuggestion(suggestion, i)">
				<span class="suggestion-name">{{suggestion.name}}</span>
				<button
					class="icon-btn add-suggestion-button"
					(click)="onAddSuggestion(suggestion, i); $event.stopPropagation()">
					<mat-icon>add</mat-icon>
				</button>
			</div>
		</div>

		<!-- Empty State -->
		<div *ngIf="!isLoading && !error && hasAnalyzed && suggestions.length === 0" class="empty-state">
			<p>No suggestions found</p>
			<button mat-button class="retry-button" (click)="onRetry()">
				<mat-icon>refresh</mat-icon>
				TRY AGAIN
			</button>
		</div>
	</div>
</div>
